import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";

import loginReducer from "./login";
import sessionReducer from "./session";

const CreateRootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    login: loginReducer,
    session: sessionReducer
  });

export default CreateRootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.ts